module.exports = __webpack_public_path__ + "static/img/homePage.d3478c6.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/img/homePage.png
// module id = ulyd
// module chunks = 55